import { NotificationDefaults } from 'store/defaults';
import NotificationPartition from './notification.partition';

/**
 * Redux Actions Reducer.
 *
 * @param {any} store current store partition state.
 * @param {any} action action dispatched.
 *
 * @returns {any} new state or store partition.
 */
export default function NotificationReducer(store = NotificationDefaults, action)
{
    const { type, payload } = action;

    switch (type)
    {
        // executes the action.
        case NotificationPartition.Type.EXEC:
            delete store.error;

            return {
                ...store,
                state: NotificationPartition.State.EXECUTING,
                data: payload
            };

        // action is successful.
        case NotificationPartition.Type.COMMIT:
            return {
                ...store,
                state: NotificationPartition.State.READY
            };

        // action was finished with errors.
        case NotificationPartition.Type.ROLLBACK:
            return {
                ...store,
                state: NotificationPartition.State.FAILED,
                error: payload
            };

        // default doesn't changes the store,
        // so, components won't re-renders.
        default:
            return store;
    }
}
